import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PedidoPedidoListModule } from '../../../../pedido/pedido/list';
import { CampanhaPedidoViewComponent } from './campanha-pedido-view.component';

@NgModule({
    imports: [
        SharedModule,
        PedidoPedidoListModule
    ],
    declarations: [
        CampanhaPedidoViewComponent
    ],
    exports: [
        CampanhaPedidoViewComponent
    ]
})
export class CampanhaPedidoViewModule { }
